module.exports = __webpack_public_path__ + "src/assets/img/home4.a8ab4b3d.jpg";